import { HIDDEN_CONTACT } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";

/**
 * Placeholder for a patient contact detail this role may not read.
 *
 * Rendered where a clickable value would normally go, so the row keeps its shape
 * and the reader can tell "hidden from you" from "not on file" — the latter
 * renders nothing at all. Inert by design: unlike the phone chip (whose chat
 * opens on the patient id), the email composer prefills from the address itself,
 * so there is nothing to act on here.
 */
export default function HiddenContact({ className }: { className?: string }) {
  return (
    <span
      title="Your role cannot view patient contact info"
      className={cx("text-foreground-secondary", className)}
    >
      {HIDDEN_CONTACT}
    </span>
  );
}
